import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectMyScopes = createSelector(
  [(state: ApplicationState) => state.MyScopeStore.data],
  (data) => data
)
